import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DeleteAccountService } from '../../services/delete-account/delete-account.service';
import { ROUTE_PATHS } from '../../utils/route-paths.const';

/**
 * Guards /delete-account-pending.
 * - Allows entry only when the session flag set right after a successful
 *   account deletion is present.
 * - Consumes (removes) the flag on entry so the one-time confirmation screen
 *   can't be revisited or refreshed back into.
 * - Any direct/cold visit without the flag falls back to HOME.
 */
export const deleteAccountPendingGuard: CanActivateFn = (): boolean => {
  const deleteAccountService = inject(DeleteAccountService);
  const router = inject(Router);

  if (deleteAccountService.wasDeletePending()) {
    deleteAccountService.clearDeletePendingFlag();
    return true;
  }

  router.navigate([ROUTE_PATHS.HOME], {
    replaceUrl: true,
    state: { bypassGuard: true },
  });
  return false;
};
